<template>
  <md-icon>{{ icon }}</md-icon>
</template>

<script>
export default {
  name: "toggle-widget",
  props: ["collapsed"],
  computed: {
    icon() {
      return this.collapsed ? "keyboard_arrow_down" : "keyboard_arrow_down";
    }
  }
};
</script>
<style scoped>
img {
  float: right;
}
</style>
